import { UAParser } from 'ua-parser-js';

export interface ParsedUa {
  browser: string | null;
  browserVersion: string | null;
  os: string | null;
  osVersion: string | null;
  deviceType: string | null;
  deviceVendor: string | null;
  deviceModel: string | null;
  engine: string | null;
}

const EMPTY: ParsedUa = {
  browser: null,
  browserVersion: null,
  os: null,
  osVersion: null,
  deviceType: null,
  deviceVendor: null,
  deviceModel: null,
  engine: null,
};

const cache = new Map<string, ParsedUa>();

export function parseUa(ua: string | null | undefined): ParsedUa {
  if (!ua) return EMPTY;
  const cached = cache.get(ua);
  if (cached) return cached;
  try {
    const r = new UAParser(ua).getResult();
    const out: ParsedUa = {
      browser: r.browser.name ?? null,
      browserVersion: r.browser.version ?? null,
      os: r.os.name ?? null,
      osVersion: r.os.version ?? null,
      deviceType: r.device.type ?? 'desktop',
      deviceVendor: r.device.vendor ?? null,
      deviceModel: r.device.model ?? null,
      engine: r.engine.name ?? null,
    };
    cache.set(ua, out);
    return out;
  } catch {
    return EMPTY;
  }
}

const DEVICE_LABEL: Record<string, string> = {
  mobile: '手机',
  tablet: '平板',
  desktop: '桌面',
  smarttv: '智能电视',
  wearable: '可穿戴',
  console: '游戏机',
  embedded: '嵌入式',
};

export function formatDeviceType(t: string | null): string {
  if (!t) return '-';
  return DEVICE_LABEL[t] ?? t;
}
